<template>
  <div class="breadcrumbs">
    <div v-for="(breadcrumb, index) in breadcrumbs" :key="index">
      <div v-if="breadcrumb.link !== undefined">
        <router-link class="breadcrumb" :to="{path: breadcrumb.link}">{{breadcrumb.name}}</router-link>/
      </div>
      <div v-else>
        <span class="breadcrumb breadcrumb_active">{{breadcrumb.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'breadcrumbs',
    props: {
        breadcrumbs: {
            type: Array,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  font-size: 11px;
  display: flex;
  color: var(--menu-text-color);
  margin-bottom: 16px;
}

.breadcrumb {
  margin: 0 3px;
  text-transform: capitalize;

  &_active {
    font-weight: bold;
  }
}
</style>
